export interface Prerequisite {
  id: string;
  label: string;
  description: string;
  required: boolean;
}

export interface PrerequisiteSelection {
  value: string;
}

export const UPLOAD_NEW_FILE_VALUE = "__upload_new_file__";

export interface IUploadPrerequisiteModalProps {
  visible: boolean;
  prerequisiteLabel: string;
  onDismiss: () => void;
  onUseFile: (file: File) => void;
}

export interface StagedPrerequisiteFile {
  prerequisiteId: string;
  documentType: string;
  file: File;
}
